import { request } from '@/utils/request'

function getLatestWatched (userId) {
  return request({
    url: '/0.3/' + userId + '/latest-watched/courses',
    method: 'get'
  })
}
export {getLatestWatched}



// WEBPACK FOOTER //
// ./src/api/header.js